import { FlagsPermissionDispatch } from "@/feature-flags/flags-dispatch";

const Layout = () =>
  import(/* webpackChunkName: "Layout" */ "@/app/ui/layout/index.vue");

// Dispatch
const DispatchList = () =>
  import(
    /* webpackChunkName: "Dispatch" */ "@/app/ui/views/out-going-shipment/dispatch/index.vue"
  );

const DispatchDetail = () =>
  import(
    /* webpackChunkName: "Dispatch" */ "@/app/ui/views/out-going-shipment/dispatch/detail.vue"
  );

const UpdateDispatch = () =>
  import(
    /* webpackChunkName: "Dispatch" */ "@/app/ui/views/out-going-shipment/dispatch/update-dispatch.vue"
  );

export default [
  {
    path: "/dispatch",
    component: Layout,
    name: "dispatch",
    meta: {
      header: true,
      icon: "delivery",
      title: "Dispatch",
      name: "Dispatch",
      customName: "Dispatch delivery",
      permission: FlagsPermissionDispatch.permission_dispatch_enable
    },
    children: [
      {
        path: "/dispatch",
        name: "dispatch",
        component: DispatchList,
        meta: {
          header: true
        }
      }
    ]
  },
  {
    path: "/dispatch",
    component: Layout,
    name: "dispatch-detail",
    meta: {
      hidden: true,
      parent: "Dispatch delivery",
      permission: FlagsPermissionDispatch.permission_dispatch_detail_view
    },
    children: [
      {
        path: ":id",
        name: "detail-dispatch",
        component: DispatchDetail,
        meta: {
          header: true,
          title: "Dispatch | Detail",
          name: "Detail Dispatch",
          before: "/dispatch"
        }
      }
    ]
  },
  {
    path: "/dispatch",
    component: Layout,
    name: "update-dispatch",
    meta: {
      hidden: true,
      parent: "Dispatch",
      permission: FlagsPermissionDispatch.permission_dispatch_update_view
    },
    children: [
      {
        path: "update",
        name: "update-dispatch",
        component: UpdateDispatch,
        meta: {
          header: true,
          title: "Dispatch | Update",
          name: "Update Dispatch",
          before: "/dispatch"
        }
      }
    ]
  }
];
